import styled from 'styled-components';

export const Container = styled.div`
  .files-card {
    border-radius: 8px;
    overflow: hidden;
  }

  .table th {
    border-top: 0;
    color: ${(props) => props.theme.$dark};
    font-weight: 600;
  }

  .table td {
    color: ${(props) => props.theme.$gray700};
  }

  .file-name {
    word-break: break-word;
  }

  .file-origin {
    font-size: 12px;
  }

  .file-preview-row td {
    border-top: 0;
  }

  .file-actions .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .file-actions .material-icons {
    font-size: 16px;
    line-height: 1;
  }
`;
